import dealer from './dealer'
import dealerOverview from './dealer-overview'
import dom from './dom'
import drillDown from './drillDown'
import enterpriseReporting from './enterprise-reporting'
import reportBuilderReport from './reportBuilderReport'
import sales from './sales'
import twofactor from './twofactor'
import user from './user'

export default {
  user,
  drillDown,
  dom,
  dealer,
  sales,
  enterpriseReporting,
  twofactor,
  dealerOverview,
  reportBuilderReport,
}
